import { botConfigs } from '@/BotConfigs/botConfigs';
import { getBotNameFromRoute } from '@/BotConfigs/botRouteMap';
import { EBotNamesBackend, IBotConfigType } from '@/types/botConfigTypes';
import { createContext, PropsWithChildren } from 'react';

interface IBotConfigContextType {
  currentBotConfig: IBotConfigType | undefined;
}

export const BotConfigContext = createContext<IBotConfigContextType | null>(
  null,
);

interface IBotConfigProps {
  botName?: EBotNamesBackend;
}

function BotConfigProvider({
  children,
  botName,
}: PropsWithChildren<IBotConfigProps>) {
  /**
   * Read from the URL rather than useParams: this provider is mounted above
   * RouterProvider in CombinedProvider, so router hooks are unavailable without
   * restructuring the tree. Safe to read during render for the same reason
   * SessionProvider does — a WebView session stays inside one bot root, since
   * native opens a single flow and nothing links across roots.
   */
  const bot =
    botName ?? getBotNameFromRoute(window.location.pathname.split('/')[1]);
  const currentBotConfig = botConfigs[bot] ?? undefined;

  if (!currentBotConfig) throw `Config for ${bot} is not defined`;

  return (
    <BotConfigContext.Provider value={{ currentBotConfig }}>
      {children}
    </BotConfigContext.Provider>
  );
}

export default BotConfigProvider;
